import sensors from '@/utils/sensors/sensors_config'
//注释部分只需服务端做
// 还款流程
export default {
    //序号27、28-Process-流程阶段
    $repayPro(process_name: any, partner_id: any, stage_name: any, if_success: any) {
        sensors.track('Process', {
            process_name,//	流程名称
            partner_id,//	合作方id
            stage_name,//	阶段名称
            if_success,//	是否成功
        })
    },
    // //序号29-RepayInitiation-还款发起
    // $repayInit(repay_amount: any,repay_status: any,repay_number: any, partner_id: any, if_success: any) {
    //     sensors.track('RepayInitiation', {
    //         repay_amount,//	还款金额
    //         repay_status,//	还款状态
    //         repay_number,//	当前期数
    //         partner_id,//	合作方id
    //         if_success,//	是否成功
    //     })
    // },
    // //序号30-RepayResult-还款发起
    // $repayResult(repay_amount: any,repay_status: any,repay_number: any, partner_id: any, if_success: any,fail_reason:any) {
    //     sensors.track('RepayResult', {
    //         repay_amount,//	还款金额
    //         repay_status,//	还款状态
    //         repay_number,//	当前期数
    //         partner_id,//	合作方id
    //         if_success,//	是否成功
    //         fail_reason,//	失败原因
    //     })
    // },
}